<!--专题活动-->
<template>
    <div class="studio_nav_content">
        <!--列表模式-->
        <div class="page-mode" v-show="showMode==='page'">
            <!-- 搜索条件 -->
            <div class="form-box">
                <div class="filter-group">
                    <div class="filter-item">
                        <span class="filter-label">活动状态</span>
                        <el-select class="filter-select" clearable @change="pageList()" v-model="queryParams.status" placeholder="请选择">
                            <el-option v-for="item in statusList" :key="item.value" :label="item.name"
                                       :value="item.value" />
                        </el-select>
                    </div>
                    <div class="filter-item">
                        <span class="filter-label">活动级别</span>
                        <el-select class="filter-select" clearable @change="pageList()" v-model="queryParams.activityLevel" placeholder="请选择">
                            <el-option v-for="item in activityLevelList" :key="item.dictKey" :label="item.dictValue"
                                       :value="item.dictKey" />
                        </el-select>
                    </div>
                    <div class="filter-item">
                        <span class="filter-label">活动方向</span>
                        <el-select class="filter-select" clearable @change="pageList()" v-model="queryParams.activityDirection" placeholder="请选择">
                            <el-option v-for="item in activityDirList" :key="item.dictKey" :label="item.dictValue"
                                       :value="item.dictKey" />
                        </el-select>
                    </div>
                </div>
                <div class="search-group">
                    <el-input class="search-input" v-model="queryParams.activityName" placeholder="请输入名称" clearable
                              @keyup.enter="pageList">
                        <template #append>
                            <el-button class="search-btn" @click="pageList">
                                <el-icon><Search /></el-icon>
                            </el-button>
                        </template>
                    </el-input>
                </div>
            </div>
            <div class="right-container">
                <div class="page-info-container">
                    <div class="info-list-container">
                        <div class="course-list-box">
                            <div class="course-item" v-for="item in dataList" :key="item">
                                <el-card :body-style="{ padding: '0px' }" class="course-one" @click="viewInfo(item)">
                                    <div class="course-name">{{item.activityName}}</div>
                                    <div class="course-info">
                                        <div class="course-cover">
                                            <img class="img-100"  :src="item.activityCover" alt />
                                        </div>
                                        <div class="course-title">
                                            <div class="course-subject">
                                                <div class="status-info-bm" v-if="item.status===1">报名阶段</div>
                                                <div class="status-info-cs" v-if="item.status===2">初审阶段</div>
                                                <div class="status-info-fs" v-if="item.status===3">复审阶段</div>
                                                <div class="status-info-zs" v-if="item.status===4">终审阶段</div>
                                                <div class="status-info-zs" v-if="item.status===5">现场评比</div>
                                                <div class="status-info-js" v-if="item.status===6">活动结束</div>
                                            </div>
                                            <div class="course-team-user">活动级别:{{item.activityLevelName}}</div>
                                            <div class="course-team-user">活动方向:{{item.activityDirectionName}}</div>
                                            <div class="course-team-user">活动负责:{{item.activityLeaderName}}</div>
                                            <div class="course-team-user">活动单位:{{item.hostOrgName}}</div>

                                        </div>
                                    </div>
                                </el-card>
                            </div>
                        </div>
                        <data-empty v-if="dataList&&dataList.length===0" title="暂无数据"/>
                    </div>
                    <div class="page-container" v-if="dataList&&dataList.length>0">
                        <pageTag :background="true"
                                 :pageSizes="[6, 9, 12]"
                                 v-show="total > 0"
                                 :total="total"
                                 v-model:page.sync="queryParams.pageNum"
                                 v-model:limit.sync="queryParams.pageSize"
                                 @pagination="pageList" />
                    </div>
                </div>
            </div>
        </div>
        <!--详情模式-->
        <div class="detail-mode" v-if="showMode==='detail'">
            <activity-info :info-id="this.infoId" @change-mode="changeModel"/>
        </div>
    </div>
</template>

<script>
import dataEmpty from "@/components/dataEmpty.vue";
import pageTag from "@/components/Pagination/page.vue";
import {timestampDate, timestampToTime} from "@/utils/date";
import {queryDict} from "@/api/admin/public";
import activityInfo from "@/components/teachResearch/activityInfo.vue";
import {activityPageWeb} from "@/api/admin/activity";

export default {
    name:'pageActivity',
    components:{activityInfo, pageTag, dataEmpty},
    props:{
        courseMode:{
            type: String,
            default:'page'
        },
        parentId:{
            type: String,
            default:''
        },
        filterItem:{
            type: String,
            default:'0'
        }
    },
    watch:{
        courseMode(newValue,oldValue){
            this.showMode = newValue;
            this.pageList();
        },
        parentId(newValue,oldValue){
            this.courseId = newValue;
        },
        filterItem:{
            immediate:true,
            handler(newValue,oldValue){
                this.activityFilter = newValue;
                this.queryParams.pageNum = 1;
                this.pageList()
            }
        },
    },
    mounted() {
        if (this.$store.state.params.jumpParams.infoId){
            this.infoId = this.$store.state.params.jumpParams.infoId;
            this.showMode = "detail"
            this.$emit('change-mode',this.showMode);
        }
        this.getQueryDict();
    },
    data() {
        return {
            showMode:'page',
            timestampDate,
            timestampToTime,
            activityFilter:this.filterItem,
            itemName:'专题活动',
            itemKey:'',
            queryParams: {
                activityName: '',
                status: '',
                activityDirection: '',
                activityLevel: '',
                itemStatus: '',
                pageNum: 1,
                pageSize: 6,
            },
            total: 0,
            pageCount:0,
            dataList: [],
            infoId:'',
            natureList:[],
            statusList: [
                { name: '报名阶段', value: 1 },
                { name: '初审阶段', value: 2 },
                { name: '复审阶段', value: 3 },
                { name: '终审阶段', value: 4 },
                { name: '现场评比', value: 5 },
                { name: '活动结束', value: 6 },
            ],
            activityLevelList:[],
            activityDirList:[],
        }
    },
    methods: {
        getQueryDict() {
            queryDict({ code: 'activity_level' }).then(res => {
                this.activityLevelList = res.data.data;
            })
            queryDict({ code: 'activity_direction' }).then(res => {
                this.activityDirList = res.data.data;
            })
        },
        pageList(){
            if (this.activityFilter === '0'){
                this.queryParams.itemStatus = ''
            }
            if (this.activityFilter === '1'){
                this.queryParams.itemStatus = '1'
            }
            if (this.activityFilter === '2'){
                this.queryParams.itemStatus = '2'
            }
            activityPageWeb(this.queryParams).then(res => {
                this.dataList = res.data.data.list;
                this.total = res.data.data.total;
                this.pageCount = res.data.data.totalPage;
            });
        },
        viewInfo(item){
            this.showMode = "detail"
            this.infoId = item.activityId;
            this.$emit('change-mode',this.showMode);
        },
        changeModel(item){
            this.showMode = item
            this.$emit('change-mode',this.showMode, 5);
        },
    }
}

</script>

<style scoped>
.studio_nav_content{
    width: 100%;
    height: auto;
    border-radius: 28px;
}
.page-mode{
    width: 100%;
    height: calc(100vh - 182px);
    background-color: #fff;
    border-radius: 28px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}
/* 搜索条件 */
.form-box{
    width: 100%;
    min-height: 70px;
    flex-shrink: 0;
    border-bottom: 2px solid #ff7f2e;
    background-color: #fff;
    padding: 10px 20px;
    box-sizing: border-box;
    border-top-left-radius: 28px;
    border-top-right-radius: 28px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
}
.filter-group{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    flex: 1;
    min-width: 0;
}
.filter-item{
    display: flex;
    align-items: center;
    gap: 6px;
}
.filter-label{
    font-size: 14px;
    color: #333;
    white-space: nowrap;
}
.filter-select{
    width: 140px;
}
.search-group{
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    gap: 12px;
    margin-left: auto;
    flex-shrink: 0;
}
.search-input{
    width: 240px;
}
.search-btn{
    background-color: #ff7f2e;
    color: #fff;
}
.search-btn:hover,
.search-btn:focus{
    background-color: #0b4a8f;
    color: #fff;
}
::v-deep .search-input .el-input-group__append{
    background-color: #ff7f2e;
    box-shadow: none;
}
.right-container{
    width: 100%;
    flex: 1;
    min-height: 0;
    display: flex;
}
.page-info-container{
    width: 100%;
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    padding-bottom: 10px;
    background-color: #fff;
    border-bottom-left-radius: 28px;
    border-bottom-right-radius: 28px;
}
.info-list-container{
    width: 100%;
    flex: 1;
    min-height: 0;
    margin: auto;
    overflow-x: hidden;
    overflow-y: auto;
}
/*课程*/
.course-list-box{
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    height: auto;
    padding-top: 15px;
    padding-left: 15px;
    align-items: center;
    box-sizing: border-box;
}
.course-item{
    width: 33.3%!important;
    height: auto;
    padding-right: 15px;
    padding-bottom: 15px;
    box-sizing: border-box;
}
.course-one{
    width: 100%;
    height: 100%;
    padding: 15px;
    border-radius: 8px;
    box-sizing: border-box;
    cursor: pointer;
}
.course-info{
    display: flex;
    width: 100%;
    height: 120px;
    padding-top: 10px;
}
.course-cover{
    width: 40%;
    height: 100%;
    box-shadow: var(--el-box-shadow-light);
    img{
        width: 100%;
        height: 100%;
    }
}
.course-title{
    width: 60%;
    height: 100%;
}
.course-name{
    width: 100%;
    font-size: 15px;
    color: #333;
    font-weight: bold;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    min-height: 42px;
}
.course-time{
    width: 100%;
    font-size: 14px;
    color: #333;
    height: 20px;
    line-height: 20px;
}
.course-subject{
    padding-left: 10px;
    box-sizing: border-box;
    font-size: 14px;
    color: #333333;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 30px;
    display: flex;
}
.status-info-cs{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #00a173;
    font-size: 12px;
    text-align: center;
    color: #fff;
    margin-top: 5px;
}
.status-info-bm{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #4095e5;
    font-size: 12px;
    text-align: center;
    color: #fff;
    margin-top: 5px;
}
.status-info-fs{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #bd3124;
    font-size: 12px;
    text-align: center;
    color: #fff;
    margin-top: 5px;
}
.status-info-zs{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #81b337;
    font-size: 12px;
    text-align: center;
    color: #fff;
    margin-top: 5px;
}
.status-info-js{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #54bcbd;
    font-size: 12px;
    text-align: center;
    color: #fff;
    margin-top: 5px;
}
.course-commend{
    padding-left: 10px;
    padding-top: 2px;
    box-sizing: border-box;
    color: #333333;
    height: 25px;
    line-height: 25px;
    font-size: 14px;
}
.course-team-user{
    padding-left: 10px;
    padding-top: 2px;
    box-sizing: border-box;
    color: #333333;
    height: 25px;
    line-height: 25px;
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.page-container{
    display: grid;
    place-items: center;
    width: 98%;
    height: 40px;
    flex-shrink: 0;
    padding-top: 15px;
    box-sizing: border-box;
}
.detail-mode{
    width: 100%;
    height: auto;
}
</style>
